import React, { useState } from 'react';
import { get } from 'lodash';
import moment from 'moment';
import axios from 'axios';
import Waypoint from 'react-waypoint';
import Loading from '../Loading';

const WalletHistoryList = ({
  walletId
}) => {
  const [isLoading, setLoading] = useState(true)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [histories, setHistories] = useState([])

  const fetchData = () => {
    if (shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/wallets/${walletId}/wallet_histories`)
      .then((res) => {
        if (res.status == 200 && get(res, 'data.histories')) {
          setHistories(res.data.histories)
          setShouldFetch(false)
          setLoading(false)
        }
      })
    }
  }

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3'>Wallet Histories</h3>
      </div>

      <Waypoint onEnter={fetchData}>
        <div className='Table Table--wallet-histories'>
          <div className='Table__row'>
            <div className='Table__col Table__col--th'>YAY User ID</div>
            <div className='Table__col Table__col--th'>Action</div>
            <div className='Table__col Table__col--th'>Reason</div>
            <div className='Table__col Table__col--th'>Final Balance</div>
            <div className='Table__col Table__col--th'>Created At</div>
          </div>

          <Loading
            isLoading={isLoading && histories.length == 0}
          >
            {histories.map((history) => (
              <div key={history.id} className='Table__row'>
                <div className='Table__col'><a className='DotTooltip__link' href={`/yay/users/${history.yay_user_id}`}>{history.yay_user_id}</a></div>
                <div className='Table__col'>{history.action}</div>
                <div className='Table__col'>{history.reason}</div>
                <div className='Table__col'>{history.final_balance}</div>
                <div className='Table__col'>{moment(history.created_at).format('YYYY-MM-DD HH:mm')}</div>
              </div>
            ))}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  )
}

export default WalletHistoryList
